var map = {
	"./apple.svg": 62411,
	"./discord.svg": 16060,
	"./drm-free.svg": 37716,
	"./epic.svg": 34040,
	"./gog.svg": 59570,
	"./google.svg": 10072,
	"./linux.svg": 89278,
	"./nintendo.svg": 19541,
	"./origin.svg": 67638,
	"./playstation.svg": 83132,
	"./steam.svg": 68162,
	"./unrealEngine.svg": 37021,
	"./uplay.svg": 82218,
	"./windows.svg": 62893,
	"./xbox.svg": 78674
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85727;